import React, { useEffect } from 'react';
import { withRouter, Redirect, Route, Switch } from 'react-router-dom';

//Page components
import HomePage from "./HomePageLayout";
import Privacy from './Privacy';
import Terms from './Terms';
import About from './About';
import Header from './Header';
import Footer from './Footer';
import Blog from './Blog';

function Main({ location }) {
    // Reset scroll on route change, or jump to the requested section (e.g. /#services).
    useEffect(() => {
        if (location.hash) {
            const target = document.getElementById(location.hash.slice(1));
            if (target) {
                target.scrollIntoView();
                return;
            }
        }
        window.scrollTo(0, 0);
    }, [location.pathname, location.hash]);

    return (
        <>
            <a className="skip-link" href="#main">Skip to content</a>
            <Header />
            <main id="main">
                <Switch>
                    <Route exact path="/" component={HomePage} />
                    <Route exact path="/privacy" component={Privacy} />
                    <Route exact path="/terms" component={Terms} />
                    <Redirect exact from="/contact" to="/" />
                    <Route exact path="/about" component={About} />
                    <Route exact path="/blog" component={Blog} />
                </Switch>
            </main>
            <Footer />
        </>
    )
}

export default withRouter(Main);
